export default __webpack_public_path__ + "images/distribution-icon.png";